module.exports = __webpack_public_path__ + "img/384fe5a.jpg";